import { t } from "i18next";
import { Course } from "../DTOs/responses/courses";

export const getCourseDetailsText = (course: Course) =>
    [
        course.semester
            ? t("semester", { count: course.semester, ordinal: true })
            : null,
        course.details,
    ]
        .filter(Boolean)
        .join(", ");